import React, { Component } from 'react';
import classNames from 'classnames';
import { Toolbar, Data } from 'react-data-grid-addons';
import { Grid, Row, Col, Panel, Button, Input, DropdownButton, MenuItem } from 'react-bootstrap';
import ReactDataGrid from 'react-data-grid';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import { Translate, Localize } from 'react-redux-i18n';
import { UI_HEIGHT } from '../Common/constants';

class CreateGroupModal extends Component {
  static contextTypes = {
    router: React.PropTypes.object
  };

  constructor() {
    super();
    this.state = {
      GroupName: "",
    }
  }

  componentDidMount() {

  }

  componentWillReceiveProps(nextProps) {

  }

  handleChange = (e) => {
    const GroupName = e.target.value;
    this.setState({ GroupName });
  }

  renderPrompt() {
    return (
        <label>
          <Input
            type='text'
            value={this.state.GroupName}
            onChange={this.handleChange}
          />
          <Translate value="group_name" />
        </label>
    );
  }

  renderButtons() {
      return (
        <span>
          <Button bsStyle="primary" className="mt mr" onClick={() => { this.props.caseAction(this.state.GroupName); this.props.closeC(); }}><em className="fa fa-check" /><Translate value="confirm" /></Button>
          <Button bsStyle="danger" className="mt mr" onClick={() => { this.props.closeC() }}><em className="fa fa-close" /><Translate value="cancel" /></Button>
        </span>
      );
  }

  render() {
    return (
      <ContentWrapper>
        <Row>
          <Col sm={ 12 } className="text-center">
            {this.renderPrompt()}
          </Col>
        </Row>
        <Row>
          <Col sm={ 12 } className="text-center">
            {this.renderButtons()}
          </Col>
        </Row>
      </ContentWrapper>
    )
  }
}

export default CreateGroupModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Sales/createGroupModal.jsx